import { createSlice } from '@reduxjs/toolkit';
import {
  UPDATE_PROFILE_STATUSES,
  type AuthenticationState,
} from 'shared/interfaces/authentication.interface';

import {
  loadUserProfileThunk,
  loginThunk,
  logoutThunk,
  updateProfileThunk,
} from './authentication.thunks';

const initialState: AuthenticationState = {
  loggedIn: false,
  updateProfileStatus: UPDATE_PROFILE_STATUSES.IDLE,
  user: null,
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    checkIsLogged: (state) => {
      const accessToken = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');
      state.loggedIn = Boolean(accessToken && refreshToken);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginThunk.fulfilled, (state) => {
        state.loggedIn = true;
      })
      .addCase(loginThunk.rejected, (state) => {
        state.loggedIn = false;
      });

    builder.addCase(logoutThunk.fulfilled, (state) => {
      state.loggedIn = false;
    });

    builder
      .addCase(updateProfileThunk.pending, (state) => {
        state.updateProfileStatus = UPDATE_PROFILE_STATUSES.PENDING;
      })
      .addCase(updateProfileThunk.fulfilled, (state) => {
        state.updateProfileStatus = UPDATE_PROFILE_STATUSES.FULFILLED;
        setTimeout(() => {
          state.updateProfileStatus = UPDATE_PROFILE_STATUSES.IDLE;
        }, 4000);
      })
      .addCase(updateProfileThunk.rejected, (state) => {
        state.updateProfileStatus = UPDATE_PROFILE_STATUSES.REJECTED;
        setTimeout(() => {
          state.updateProfileStatus = UPDATE_PROFILE_STATUSES.IDLE;
        }, 4000);
      });

    builder.addCase(loadUserProfileThunk.fulfilled, (state, action) => {
      state.user = action.payload;
    });
  },
});

export const { checkIsLogged } = authenticationSlice.actions;

export const authenticationReducer = authenticationSlice.reducer;
